export default [
  {
    path: '/mng/account/wework/AppList',
    name: 'appList',
    component: () => import('@/pages/mng/wework/AppList/App.vue'),
    meta: {
      title: '员工服务',
      dataUrl: '',
    },
  },
  {
    path: '/mng/account/wework/AppDetail',
    name: 'appDetail',
    component: () => import('@/pages/mng/wework/AppDetail/App.vue'),
    meta: {
      title: '应用基础设置',
      dataUrl: '',
    },
  },
  {
    path: '/mng/account/wework/AppPrivilege',
    name: 'appPrivilege',
    component: () => import('@/pages/mng/wework/AppPrivilege/App.vue'),
    meta: {
      title: '应用菜单设置',
      dataUrl: '',
    },
  },
];
